export default {
  saveAvatarStatus: null,
  saveSignatureStatus: null,
  editChangesRequestedStatus: null,
  designerDataStatus: null,
  designerStatsStatus: null,
  designerStats: null
}